import { Trophy } from 'lucide-react';
import ProximoJogoWidget from '../ProximoJogoWidget';
import type { FutebolJogoDia } from '@/shared/types';

interface Props {
  proximoJogo: FutebolJogoDia | null;
}

export function JogoIdleHub({ proximoJogo }: Props) {
  return (
    <div className="flex flex-1 flex-col space-y-4 px-4 pb-24 pt-4">
      {proximoJogo ? <ProximoJogoWidget jogo={proximoJogo} /> : null}

      {!proximoJogo && (
        <div className="flex flex-col items-center py-12 text-center">
          <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-2xl bg-white/[0.04] ring-1 ring-white/[0.06]">
            <Trophy size={28} className="text-white/25" />
          </div>
          <h2 className="mb-1 text-base font-bold text-white/70">Nenhum jogo no ar</h2>
          <p className="max-w-xs text-sm text-white/35">
            Quando houver partida na grade, o placar sobe aqui.
          </p>
        </div>
      )}
    </div>
  );
}
